<template>
  <div v-if="companyData">
    <h1>Public Widget</h1>
    <h3>Route Id: {{ $route.params.company_id }}</h3>
    <h3>
      Company Info: {{ companyData.name }}
    </h3>

    <h2>Testing simple-peer start...</h2>
    <button @click="CreateSimplePeer">
      Create Peer and Send Data
    </button>

    <h2>Local Stream</h2>
    <video class="video" autoplay :src-object.prop.camel="localStream" muted></video>

    <h2>Remote Stream</h2>
    <video class="video" autoplay :src-object.prop.camel="remoteStream"></video>

  </div>
</template>

<script>
// import firebase from "firebase";
import firebase from '@/utils/firebase'
import Peer from 'simple-peer'

export default {
  data() {
    return {
      companyData: null,
      peerData: null,
      localStream:null,
      remoteStream:null,
      newConversation:null
    }
  },

  methods: {
    getCompany(company_id){
      firebase.database().ref('companies/' + company_id)
      .once('value', snapshot => {
        this.companyData = snapshot.val()
      });
    },

    //Simple Peer Test
    CreateSimplePeer(){
      navigator.mediaDevices.getUserMedia({ video: true, audio: true })
      .then(stream => {
        //first need to create the conversation... then add the peer_data stream too it

        //first add a new conversation
        const convRef = firebase.database().ref('conversations')
        const newConversation = convRef.push({
          company_id: this.$route.params.company_id,
          created_at: firebase.database.ServerValue.TIMESTAMP
        });
        this.newConversation =  newConversation

        //create a peer - trickle false works
        var peer = new Peer({
          initiator: true,
          trickle: true,
          stream: stream,
          config: {'iceServers': [
            {'urls': 'stun:stun.services.mozilla.com'},
            {'urls': 'stun:stun.l.google.com:19302'},
            {'urls': 'turn:numb.viagenie.ca','credential': 'beaver','username': 'webrtc.websitebeaver@gmail.com'}
          ]}
        })
        // console.log(peer)


        this.localStream = stream

        peer.on('error', (err) => {console.log(err)})

        const peerDataRef = firebase.database().ref('conversations/'+ newConversation.key + '/peer_data/')

        //wait for new peer data from the dashboard
        peerDataRef.on("child_added", function(snapshot) {
          const appData = snapshot.val();
          if (appData.source === "dashboard"){
            peer.signal(appData.data);
          }
        });


        //signal back and fourth
        peer.on('signal', data => {

          this.peerData = data

          //send new peer data from the widget to the dashboard
          const updatedPeerData = peerDataRef.push({
            data: data,
            source: 'widget'
          })

        })
        //capture local stream
        peer.on('stream', stream => {
          // got remote video stream, now let's show it in a video tag
          this.remoteStream = stream;
        });

        peer.on('close', () => {
          console.log('THE PEER HAS BEEN CLOSED M8')
          this.localStream = null;
          this.remoteStream = null;
        });
      })
      .catch(function(err) {
        console.log(err)
      });
    },
  },

  mounted () {
    this.getCompany(this.$route.params.company_id)
  }
}
</script>

<style lang="css" scoped>

.video {
  width: 40vw;
}
</style>
